// TODO - DODAĆ TEKSTY DO MONGO


import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import useTextContents from '../../hooks/useTextContents'
import { ReactComponent as MObywatelIcon } from '../../icons/svg/mObywatel-icon.svg'
import { ReactComponent as VideoVerificationIcon } from '../../icons/svg/video-verification-icon.svg'
import { ReactComponent as ManualVerificationIcon } from '../../icons/svg/manual-verification-icon.svg'
import { AppLinks } from '../../environment/app-links'
import analyticsService from '../../service/analytics.service'
import PageScreen from '../../components/organisms/Page/PageScreen'
import Paragraph from '../../components/atoms/Paragraph/Paragraph'
import { APP_FONT_SIZE } from '../../components/atoms/AtomsGlobalProps'
import PageHeader from '../../components/atoms/PageHeader/PageHeader'
import { HEADER_LEVEL } from '../../components/atoms/PageHeader/PageHeaderProps'
import TileButton from '../../components/atoms/TileButton/TileButton'
import { apphistory, AppState } from '../../store'
import {STORAGEKEYS} from "../../common/keys";
import LoanOfferSummaryPanel from "../../components/organisms/LoanOfferSummaryPanel/LoanOfferSummaryPanel";

import './ClientChoiceVerificationPage.scss'


/**
 * Komponent wyświetlający stronę z wyborem weryfikacji manualnej dla klienta.
 * @returns
 */
const ClientChoiceVerificationPage = () =>{
    const textContent = useTextContents()
    const ANALYTICS_EVENT_TYPES_NAMES = useSelector((state: AppState) => state.lenConfigState.analyticsEventTypesNames)

    useEffect(() => {
        if(sessionStorage.getItem(STORAGEKEYS.MOBYWATEL_IS_FIRST_RENDER) !== null ){
            sessionStorage.removeItem(STORAGEKEYS.MOBYWATEL_IS_FIRST_RENDER);
            sessionStorage.removeItem(STORAGEKEYS.CURRENT_MOBYWATEL_CODE);
            sessionStorage.removeItem(STORAGEKEYS.MOBYWATEL_CODE_EXPIRED_TIME);
            sessionStorage.removeItem(STORAGEKEYS.MOBYWATEL_IS_AFTER_FIRST_RENDER);
        }

        (async () => {
            if(ANALYTICS_EVENT_TYPES_NAMES !== null && ANALYTICS_EVENT_TYPES_NAMES !== undefined){
                await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES.ManualVerificationPageDisplayed)
            }
        })()
    }, [])

    return (
        <PageScreen 
            title={{ title: "Potwierdź wypłatę", line: true }}
            panel={<LoanOfferSummaryPanel readOnly={true} loanVariant='selectedOffer' />}
        >
            <Paragraph className='client-choice-verification-page-full-margin-bottom'>
                Ostatni krok przed wypłatą pożyczki. Wybierz jeden ze sposobów potwierdzenia:
            </Paragraph>
            <PageHeader level={HEADER_LEVEL.H2} title='W pełni samodzielnie' className='client-choice-verification-page-half-margin-bottom' />
            <Paragraph  className='client-choice-verification-page-half-margin-bottom'>
                Wypłata od razu, bez konsultanta, dostępna 24/7.
            </Paragraph>
            <div className='client-choice-verification-page-main-tiles-wrapper'>
                <TileButton
                    heading='Aplikacja mObywatel'
                    description='Potwierdź jednym kliknięciem'
                    icon={MObywatelIcon}
                    isRecommended
                    onClick={async () =>  {
                        await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.ManualVerificationMobywatelMethodSelect)
                        apphistory.push(AppLinks.manualVerificationMObywatelIdentityPage)
                    }}
                />
                <TileButton
                    heading='Wideoweryfikacja'
                    description='Zrób zdjęcie twarzy i dowodu osobistego'
                    icon={VideoVerificationIcon}
                    onClick={async () =>  {
                        await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.ManualVerificationVideoVerificationMethodSelect)
                        apphistory.push(AppLinks.videoVerificationStartManualVerificationPage)
                    }}
                />
            </div>
            <PageHeader level={HEADER_LEVEL.H2} title='Z pomocą konsultanta' className='client-choice-verification-page-half-margin-bottom' />
            <Paragraph  className='client-choice-verification-page-half-margin-bottom'>
                Zadzwonimy w dni robocze, w godz. 8:00–17:00, wypłata natychmiast po rozmowie.
            </Paragraph>
            <TileButton
                heading='Telefonicznie'
                description='Porozmawiaj z nami'
                icon={ManualVerificationIcon}
                onClick={async () =>  {
                    await analyticsService.createSingleAnalyticEvent(ANALYTICS_EVENT_TYPES_NAMES?.ManualVerificationManualVerificationMethodSelect)
                    apphistory.push(AppLinks.manualVerification)
                }}
            />
        </PageScreen>
    )
}

export default ClientChoiceVerificationPage;